import LodgeSection from './LodgeSection';
import CoverageSection from './CoverageSection';
import FlightPriceComparison from './FlightPriceComparison';
import CommonFAQ from './CommonFAQ';
import { AboutJomson, JomsomFAQ } from './Jomsom';
import { AboutLukla, LuklaFAQ, RamechhapFAQ } from './Lukla';
import ImportantNotice from './ImportantNotice';
import ComparePricesSection from './ComparePricesSection';
import CoronaVirusNotice from './CoronaVirusNotice';

// import RamechhapFAQ from './ramechhap';

export {
  ImportantNotice,
  CoverageSection,
  FlightPriceComparison,
  LodgeSection,
  CommonFAQ,
  AboutJomson,
  JomsomFAQ,
  AboutLukla,
  LuklaFAQ,
  RamechhapFAQ,
  ComparePricesSection,
  CoronaVirusNotice,
};



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/index.js